import { Box, Typography, Container } from '@mui/material';
import { useGlobalState } from "../contexts/GlobalState";
import { useEffect } from 'react';

export const ContactInfo = () => {
    const { setBreadcrumbsText } = useGlobalState();

    useEffect(() => {
        setBreadcrumbsText(["Home", "Contact Info"]);
    }, []);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ textAlign: 'center', py: 8 }}>
                <Typography variant="h4" gutterBottom>
                    Contact Info
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                    Contact information will be available here.
                </Typography>
            </Box>
        </Container>
    );
};
